// Rotas de Web Push conforme contrato com api-rh-digital
export const PUSH_VAPID_PUBLIC_KEY_PATH = '/push/vapid-public-key';
export const PUSH_SUBSCRIPTIONS_PATH = '/push/subscriptions';

export const PENDING_DEEP_LINK_STORAGE_KEY = 'rh-digital:pendingDeepLink';
export const PUSH_OPT_IN_DISMISSED_STORAGE_KEY = 'rh-digital:pushOptInDismissed';

export const DEFAULT_PUSH_ICON = '/newIcon192.png';
export const DEFAULT_PUSH_TITLE = 'RH Digital';
export const SOLICITACAO_PUSH_TITLE = 'Atualização de solicitação';
